import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-format-color-picker",
  "use": "icon-format-color-picker-usage",
  "viewBox": "0 0 32 24",
  "content": "<symbol viewBox=\"0 0 32 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-format-color-picker\">\n<path d=\"M5.36523 17H7.53223L9.94531 9.10449H10.0684L12.4746 17H14.6484L11.2168 7.13574H8.79004L5.36523 17ZM7.41602 14.6074H12.5225V13.0625H7.41602V14.6074Z\" fill=\"currentColor\" />\n<path d=\"M21 11L24 14L27 11\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol